// Copyright (c) 2017 Deere & Company

import * as ProductSearchHelper from '../../shared/services/product-search-helper';
import {
    createErrorObject,
    errorAlertBar
} from '../../../shared/services/alert-bar';
import actions from '../../actions-list';
import {routerActions} from 'react-router-redux';
import {translate} from '../../../shared/services/translation-service';

export const updateQuery = (queryString, type) =>
    dispatch => dispatch({
        data: queryString,
        state: type,
        type: actions.UPDATE_QUERY
    });

export const onSearch = (searchBy, query) =>
    dispatch => {

        if (ProductSearchHelper.mapProductValidation(searchBy, query)) {

            dispatch(routerActions.push(`/products/search?by=${searchBy}&q=${encodeURIComponent(query)}`));

        } else {

            const translatedErrorMessage = translate(ProductSearchHelper.mapValidationErrorMessages(searchBy));

            errorAlertBar(createErrorObject(translatedErrorMessage));

        }

    };



// WEBPACK FOOTER //
// ./src/product/shared/action-creators/search-box.js